import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Action, Box, MenuElement, MenuList } from './theme'

const IconElement = ({ icon: Icon, action, children, isSelected, show = true, disabled = false, onClick }) => {
  console.log(disabled)

  const onAction = () => {
    if (onClick) {
      onClick()
    }
    action()
  }

  return (<Fragment>
        {show && (
            <MenuElement>
              <Action style={disabled? {cursor: 'not-allowed'}:{}} isSelected={isSelected} onClick={disabled? undefined:onAction}>
                {Icon && <Icon />} {children}
              </Action>
            </MenuElement>
        )}
      </Fragment>
  )
}

IconElement.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(React.Component)]),
  action: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  isSelected: PropTypes.bool,
}

const FrameMenu = ({ children, show = false, isSidebarOpen = false }) => (
  <Fragment>
    {show && (
      <Box isSidebarOpen={isSidebarOpen}>
        <MenuList>{children}</MenuList>
      </Box>
    )}
  </Fragment>
)
FrameMenu.propTypes = {
  children: PropTypes.any.isRequired,
  show: PropTypes.bool,
  isSidebarOpen: PropTypes.bool,
}

export default FrameMenu
export { IconElement }



// WEBPACK FOOTER //
// ./src/components/FrameMenu/index.js